import { Box, Image } from '@chakra-ui/react';
import * as React from 'react';

import { ImagePreview } from '@/components/ImagePreview';
import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';

export const ProfileImage: React.FC<{
  src?: string;
  alt: string;
  newView?: boolean;
  preview?: boolean;
}> = (props) => {
  const image = props.src ? (
    <Box
      h={props.newView ? '68px' : '36'}
      w={props.newView ? '68px' : '36'}
      p="2"
      boxShadow="base"
      borderRadius="lg"
      bg="white"
      fontSize="10px"
    >
      <Image
        src={props.src}
        h="full"
        w="full"
        objectFit="contain"
        alt={props.alt}
      />
    </Box>
  ) : (
    <ImageFallback
      h={props.newView ? '68px' : '36'}
      w={props.newView ? '68px' : '36'}
      borderRadius="lg"
    />
  );

  if (!props.preview || !props.src) {
    return image;
  }

  return (
    <ImagePreview src={props.src} alt={props.alt}>
      {image}
    </ImagePreview>
  );
};